import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickAggregation from '@/components/brick_aggregation.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-hexagon', 'text-red']
infos.front_classes = [
  'fas',
  'fa-share-alt',
  'fa-flip-horizontal',
  'text-white',
]
infos.name = 'aggregation'
infos.associated_class_name = 'AutomlAggregation'
infos.editing_component_name = 'BrickAggregation'
infos.editing_component = BrickAggregation
infos.descriptions = {
	en: {
		short_tooltip_description: 'Aggregation',
		full_tooltip_description:
			'Automatic aggregation for which the database schema must be input',
		navbar_name: 'Aggregation',
	},
	fr: {
		short_tooltip_description: 'Agrégation',
		full_tooltip_description:
			"Paramétrage des options de l'agrégation automatique. Définition du schéma relationnel des tables utilisées en entrée",
		navbar_name: 'Agrégation',
	},
}
// infos.short_tooltip_description = 'aggregation_short_tooltip'
// infos.full_tooltip_description = 'aggregation_full_tooltip'
// infos.navbar_name = 'aggregation_navbar'
infos.background_color = 'red'

brick_registerer(infos)
